module.exports = __webpack_public_path__ + "img/hcvi-logo.93a8cc8.png";